import "./PhoneComp.css";
import { defineComponent as i, resolveComponent as r, openBlock as p, createBlock as u, withCtx as m, createElementVNode as a, createVNode as y, withModifiers as h, normalizeClass as g, toDisplayString as b } from "vue";
import { MaskComp as C } from "./MaskComp.js";
import { CountryFlagSelectComp as c } from "./CountryFlagSelectComp.js";
import { V as v } from "./WrapperComp.204dcf4e.js";
import { _ as f } from "./_plugin-vue_export-helper.dad06003.js";
const M = i({
  components: {
    MaskComp: C,
    CountryFlagSelectComp: c
  },
  mixins: [v],
  events: {
    "update:modelValue": {
      type: String
    },
    "update:errorMessages": {
      type: Array
    },
    "update:country": {
      note: "used as a v-model:country on this component"
    }
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: String,
      default: null,
      note: "phone number"
    },
    country: {
      type: Object,
      default: null,
      note: "phone country"
    },
    validationRules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    label: String,
    supportingText: String,
    width: String,
    readonly: Boolean,
    disabled: Boolean,
    labelAbove: Boolean,
    /**
     * Used for disabling error or info messages from being seen or validation from running
     */
    disableMessages: Boolean,
    /**
     * Used for determining when to run the validation rules on input
     */
    validateOn: {
      type: String,
      default: "blur"
    }
  },
  computed: {
    phoneNumber: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    phoneCountry: {
      get() {
        return this.country;
      },
      set(e) {
        this.$emit("update:country", e);
      }
    },
    countryCodeClasses() {
      return {
        phone__countryCode: !0,
        "phone__countryCode--error": this.isErrorState,
        "phone__countryCode--disabled": this.disabled
      };
    }
  },
  methods: {
    handleUpdateErrorMessages(e) {
      this.$emit("update:errorMessages", e);
    },
    validate() {
      const e = this.$refs.phoneComp.validate();
      return this.$emit("update:errorMessages", e), e;
    }
  }
});
const V = { class: "phone__prepend" };
function _(e, o, S, $, k, A) {
  var s;
  const n = r("country-flag-select-comp"), l = r("mask-comp");
  return p(), u(l, {
    class: "phone",
    ref: "phoneComp",
    id: e.id,
    modelValue: e.phoneNumber,
    "onUpdate:modelValue": o[2] || (o[2] = (t) => e.phoneNumber = t),
    mask: (s = e.phoneCountry) == null ? void 0 : s.value.phoneMask,
    label: e.label,
    supportingText: e.supportingText,
    "onUpdate:errorMessages": e.handleUpdateErrorMessages,
    errorMessages: e.errorMessages,
    validationRules: e.validationRules,
    disableMessages: e.disableMessages,
    validateOn: e.validateOn,
    width: e.width,
    readonly: e.readonly,
    placeholder: "9999999999",
    disabled: e.disabled,
    labelAbove: e.labelAbove,
    autocomplete: "tel-national"
  }, {
    prepend: m(() => {
      var t;
      return [
        a("div", V, [
          y(n, {
            onClick: o[0] || (o[0] = h(() => {
            }, ["stop"])),
            id: `${e.id}-country`,
            class: "countryFlagSelect",
            modelValue: e.phoneCountry,
            "onUpdate:modelValue": o[1] || (o[1] = (d) => e.phoneCountry = d),
            disabled: e.disabled
          }, null, 8, ["id", "modelValue", "disabled"]),
          a("span", {
            class: g(e.countryCodeClasses)
          }, "+" + b((t = e.phoneCountry) == null ? void 0 : t.value.phoneCountryCode), 3)
        ])
      ];
    }),
    _: 1
  }, 8, ["id", "modelValue", "mask", "label", "supportingText", "onUpdate:errorMessages", "errorMessages", "validationRules", "disableMessages", "validateOn", "width", "readonly", "disabled", "labelAbove"]);
}
const R = /* @__PURE__ */ f(M, [["render", _], ["__scopeId", "data-v-21509735"]]);
export {
  R as PhoneComp
};
//# sourceMappingURL=PhoneComp.js.map
